<template>
    <div>
        <h1 class="py-4">{{title}}</h1>
        <div v-if="isLoading">
            <loading-spinner-small />
        </div>
        <div v-else>
            <div class="mt-4 alert alert-error" v-if="isErrored">
            {{ CONSTANTS.SERVER_ERROR_MESSAGE }}
            </div>
            <div v-else>
                <div>
                    <event-feed-filters 
                        :topics="topics"
                        :reset-filters="resetFilters"
                        @updateSearchTerm="handleSearch($event)" 
                        @updateDateFilterValue="handleDateFilterChange($event)"
                        @interestsSaved="resetEventsFeed">
                    </event-feed-filters>
                </div>
                <div>
                    <div class="mt-4" v-if="filteredEvents && filteredEvents.length > 0">
                        <div v-for="event in filteredEvents" :key="event.uniqueId">
                            <div class="pb-3">
                                <event-feed-card 
                                  :event-data="event" 
                                  :user-email="user.email"
                                  :outlook-id="getOutlookId(event.uniqueId)"
                                  :isAddedToCalendar="setIsAddedToCalendar(event.uniqueId)"
                                  :isAddedToRSVP="setIsAddedToRSVP(event.uniqueId)">
                                </event-feed-card>
                            </div>
                        </div>
                        <div class="load-more-wrapper d-flex justify-content-center pb-4">
                            <div class="d-flex justify-content-center pb-4">
                                <div v-if="isMoreLoading" class="more-loading-spinner">
                                    <img :src="spinnerUrl" alt="Loading Spinner" />
                                </div>
                                <div
                                    v-else-if="showLoadMore"
                                    class="homebase-btn-secondary"
                                    @click="onLoadMoreClicked">
                                    Load more
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="mt-4">No events to display</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
import * as CONSTANTS from "@/store/constants";
import LoadingSpinnerSmall from "@/components/LoadingSpinnerSmall"
import EventFeedCard from "./../eventsByInterests/EventFeedCard";
import EventFeedFilters from "./../eventsByInterests/EventFeedFilters";

export default {
  name: "event-feed",
  components: {
    LoadingSpinnerSmall,
    EventFeedCard,
    EventFeedFilters
  },
  computed: {
      ...mapGetters(["user"])
  },
  data() {
    return {
      searchTerm: "",
      dateValue: null,
      filteredEvents: [],
      resetFilters: false,
      spinnerUrl: HH_COMPONENTS_URL + "/spinner.svg"
    };
  },
  props: [
    "title",
    "isLoading",
    "isMoreLoading",
    "showLoadMore",
    "isErrored",
    "events",
    "calendarEvents",
    "topics"
  ],
  watch: { 
    events: function(events) {
      this.resetFilters = false;
      this.setFilteredEvents(events);
    }
  },
  methods: {
    handleSearch(payload) {
      const searchTerm = payload && payload.length > 0 ? payload.toLowerCase() : null;
      this.handleFiltering(searchTerm, this.dateValue);
      this.searchTerm = searchTerm;
    },
    handleDateFilterChange(dateValue) {
      this.dateValue = dateValue;
      this.handleFiltering(this.searchTerm, this.dateValue);
    },
    handleFiltering(searchTerm, filteredDateValue) {
      const filterEnabled = (searchTerm || filteredDateValue);

      if(filterEnabled) {
        let filteredEvents = this.events;

        if(filteredDateValue) {
          filteredEvents = filteredEvents.filter((e) => {
            const startDate = moment(e.startDate).format("YYYY-MM-DD");
            const endDate = moment(e.endDate).format("YYYY-MM-DD");
            if(filteredDateValue.end) {
              return filteredDateValue.start <= endDate && filteredDateValue.end >= startDate;
            } else {
              return startDate >= filteredDateValue.start;
            }
          });
        }

        if(searchTerm) {
          filteredEvents = filteredEvents.filter((e) => {
            return e.title.toLowerCase().includes(searchTerm);
          });
        }

        this.setFilteredEvents(filteredEvents);
      }
      else {
        this.setFilteredEvents(this.events);
      }
    },
    setIsAddedToCalendar(eventUniqueId) {
      return this.calendarEvents.some((e) => e.id === eventUniqueId);
    },
    setIsAddedToRSVP(rsvpUniqueId) {
      
      let filteredEvents = this.events.filter((e)=>e.uniqueId === rsvpUniqueId)
      if(filteredEvents[0] && filteredEvents[0].rsvpUsers && filteredEvents[0].rsvpUsers.length>0){
        let rsvpUsers = filteredEvents[0].rsvpUsers.map(key=>key.email);
        if(rsvpUsers.indexOf(this.user.email) != -1){
          return true
        }
      }
      return false
    },
    getOutlookId(eventUniqueId){
      let filteredEvents = this.calendarEvents.filter((e)=>e.id === eventUniqueId)
      return filteredEvents[0]? filteredEvents[0].outlookId : null;
    },
    setFilteredEvents(events) {
      this.filteredEvents = events;
    },
    resetEventsFeed() {
      this.$emit("interestsSaved");
    },
    onLoadMoreClicked() {
      this.resetFilters = true;
      this.$emit("onLoadMore");
    },
  }
};
</script>
<style scoped>
.load-more-wrapper {
  margin-top: 30px;
}
.more-loading-spinner img {
  height: 50px;
}
</style>
